module.exports = __webpack_public_path__ + "media/images/cathay@2x-7a5ee0cf559eb378ab94ec742e36628c.png";